import { Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Counter = ({ count, firstSite, onClick, selectedSite, maxWidth = '350px', exceedsLimit = false }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const displayText = count === 1 && firstSite 
    ? firstSite.label 
    : `${count} ${t('arborist.selected_sites')}`

  return (
    <Typography
      variant="caption"
      onClick={onClick}
      title={displayText}
      sx={{
        cursor: 'pointer',
        color: (selectedSite && !exceedsLimit) ? theme.palette.text.body.secondary : theme.palette.primary.main,
        maxWidth,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
      {displayText}
    </Typography>
  )
}

export default Counter
